import React, { useState, useEffect } from 'react';

const API = window.location.hostname === 'localhost'
  ? 'http://localhost:5000/api'
  : 'https://myssa1.osc-fr1.scalingo.io/api';

const cardStyle = {
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  height: '140px',
  width: '210px',
  padding: '14px 18px 14px 22px',
  background: '#ffffff',
  border: '0.5px solid #E5E7EB',
  borderRadius: '10px',
  overflow: 'hidden',
};

const accentStyle = {
  position: 'absolute',
  left: 0, top: 0, bottom: 0,
  width: '3px',
  borderRadius: '10px 0 0 10px',
  background: '#378ADD',
};

const tagStyle = {
  fontSize: '10px',
  fontWeight: '600',
  letterSpacing: '0.8px',
  textTransform: 'uppercase',
  color: '#9CA3AF',
  marginBottom: '8px',
};

const valueStyle = {
  fontSize: '22px',
  fontWeight: '500',
  color: '#185FA5',
  lineHeight: '1',
  marginBottom: '6px',
};

const subStyle = {
  fontSize: '12px',
  color: '#6B7280',
};

const Card6 = ({ title }) => {
  const [montantEOY, setMontantEOY] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchAll = async () => {
      try {
        const [resMontantVente, resOffre] = await Promise.all([
          fetch(`${API}/montant_vente`),
          fetch(`${API}/offre`),
        ]);

        if (!resMontantVente.ok) throw new Error(`Erreur API montant_vente : ${resMontantVente.status}`);
        if (!resOffre.ok) throw new Error(`Erreur API offre : ${resOffre.status}`);

        const dataMontantVente = await resMontantVente.json();
        const dataOffre = await resOffre.json();

        let montantCard3 = 0;
        if (Array.isArray(dataMontantVente)) {
          montantCard3 = dataMontantVente.reduce((acc, row) => {
            const val = parseFloat(row.Montant ?? row.montant ?? 0);
            return acc + (isNaN(val) ? 0 : val);
          }, 0);
        } else {
          montantCard3 = parseFloat(dataMontantVente.montant ?? dataMontantVente.Montant ?? dataMontantVente.total ?? 0);
        }

        let montantCard4 = 0;
        if (Array.isArray(dataMontantVente)) {
          montantCard4 = dataMontantVente.reduce((acc, row) => {
            const val = parseFloat(row.Backlog ?? row.backlog ?? 0);
            return acc + (isNaN(val) ? 0 : val);
          }, 0);
        } else {
          montantCard4 = parseFloat(dataMontantVente.Backlog ?? dataMontantVente.backlog ?? 0);
        }

        let montantCard5 = 0;
        if (Array.isArray(dataOffre)) {
          montantCard5 = dataOffre.reduce((acc, row) => {
            const val = parseFloat(row.Ptot ?? row.ptot ?? 0);
            return acc + (isNaN(val) ? 0 : val);
          }, 0);
        } else {
          montantCard5 = parseFloat(dataOffre.Ptot ?? dataOffre.ptot ?? dataOffre.total ?? 0);
        }

        const total = montantCard3 + montantCard4 + montantCard5;
        setMontantEOY(isNaN(total) ? null : total);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchAll();
  }, []);

  const formattedValue = montantEOY !== null
    ? new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(montantEOY)
    : '—';

  return (
    <div style={cardStyle}>
      <div style={accentStyle} />
      <div style={tagStyle}>Montant vente EOY</div>
      <div style={valueStyle}>
        {loading ? 'Chargement…' : error ? 'Erreur' : formattedValue}
      </div>
      <div style={subStyle}>Projection fin d'année</div>
    </div>
  );
};

export default Card6;